import styled from 'styled-components'

export const Container = styled.div.attrs({
  role: 'cell'
})`
  display: flex;
  flex-wrap: wrap;
  column-gap: 3px;
`

const Text = styled.span`
  align-self: center;
  font-family: 'Inter';
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Type = styled(Text)``
export const Unit = styled(Text)``
